export default {
  images: ['image/*'],
  // csv: ['text/csv'],
  maxFileSize: Number(12582912), //Number(process.env.REACT_APP_FILE_SIZE_LIMIT), <- this is the original value, but on Dev this was returning NaN
}
